import { useEffect, useContext } from "react";
import { Navigate } from "react-router-dom";
import UserContext from "../context/UserContext";

function Logout() {
  const { setUser } = useContext(UserContext);

  useEffect(() => {
    localStorage.removeItem("token");
    setUser(null);
  }, []);
  return <Navigate to="/products" />;
}

export default Logout;
